var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgEdit = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.59994L16.2 4.99994L19 7.79994L19.4 7.39994C20.2 6.59994 20.2 5.29994 19.4 4.49994C18.6 3.79994 17.3 3.79994 16.5 4.59994Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90002 17.1L5.40002 15.7L15.1 6L16.5 7.5L6.90002 17.1Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30002 18.6L6.90002 17.1L16.5 7.5L18 8.9L8.30002 18.6Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7.8L16.2 5L15.1 6L16.5 7.5L18 8.9L19 7.8Z",
    fill: "#444447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89995 17.1L5.39995 15.7L4.69995 17.8L6.19995 19.3L8.29995 18.6L6.89995 17.1Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 19.3L4.7 17.8L4 20L6.2 19.3Z",
    fill: "url(#paint4_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20.6961,
    y1: 3.29024,
    x2: 16.7773,
    y2: 7.20904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 5.93842,
    y1: 5.5312,
    x2: 12.5804,
    y2: 13.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9342,
    stopColor: "#3C6CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 24.2032,
    y1: 8.9729,
    x2: 9.85642,
    y2: 13.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9342,
    stopColor: "#3C6CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 4.77242,
    y1: 16.9582,
    x2: 8.19875,
    y2: 18.7543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1975,
    stopColor: "#FDD354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 6.36391,
    y1: 17.5354,
    x2: 4.86597,
    y2: 19.1953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Edit.a2371d32.svg";
export { ForwardRef as ReactComponent };